import { SET_OPTIN_DATA } from '../actions/types';

export default function optIns(state = {}, action = null) {
	if (!action.error && action.payload && action.type) {
		switch (action.type) {
			case SET_OPTIN_DATA:
				return { ...state, optIns: action.payload };
			default:
				break;
		}
	}
	return state;
}
